export default __webpack_public_path__ + "static/media/4.43f91328.png";